import type { ThemeOptions } from "@mui/material";

export const BRUKY_COLORS: ThemeOptions = {
  palette: {
    primary: { main: "#0038A8", dark: "#002F63" },
    secondary: { main: "#6DBD70", dark: "#33663F" },
    text: {
      primary: "#3A4F66",
      secondary: "#fff",
    },
    backgrounds: {
      pageGradient:
        "linear-gradient(180deg, rgba(0,47,99,0.3) 0%, rgba(0,56,168,0.3) 33%, rgba(109,189,112,0.3) 66%, rgba(51,102,63,0.3) 100%), #fff",
      sectionGradient:
        "radial-gradient(circle, rgba(51,102,63,0.3) 0%, rgba(109,189,112,0.3) 33%, rgba(0,56,168,0.3) 68%, rgba(0,47,99,0.3) 100%), #FFF",
    },
    charts: {
      primary: "#0038A8",
      secondary: "#6DBD70",
      primaryDark: "#002F63",
      secondaryDark: "#33663F",
      border: "none",
    },
  },
};
